<script>
  // Wizard shell used by Campaigns/Boosts/Quests. `steps`: [{ key, label, summary? }] where
  // `summary` is an optional snippet (declared in the parent, e.g. {#snippet setupSummary()}...{/snippet})
  // shown under the step label once it's no longer active. Content per step comes from the
  // `step` snippet, called as {@render step(activeIndex, steps[activeIndex])}.
  let {
    steps = [],
    activeIndex = $bindable(0),
    errorSteps = [],
    step,
    footer
  } = $props()

  const jumpTo = (index) => {
    activeIndex = index
  }

  const back = () => jumpTo(Math.max(0, activeIndex - 1))
  const next = () => jumpTo(Math.min(steps.length - 1, activeIndex + 1))
  const isLast = $derived(activeIndex === steps.length - 1)
</script>

<div class="flex gap-6">
  <aside class="w-64 shrink-0">
    <ul class="steps steps-vertical">
      {#each steps as stepItem, index (stepItem.key)}
        <li
          class="step cursor-pointer text-left"
          class:step-primary={index <= activeIndex}
          class:step-error={errorSteps.includes(stepItem.key)}
        >
          <button type="button" class="text-left w-full" onclick={() => jumpTo(index)}>
            <span class="font-medium" class:text-error={errorSteps.includes(stepItem.key)}>{stepItem.label}</span>
            {#if index !== activeIndex && stepItem.summary}
              <div class="text-xs text-base-content/60">{@render stepItem.summary()}</div>
            {/if}
          </button>
        </li>
      {/each}
    </ul>
  </aside>

  <div class="flex-1 min-w-0">
    <div class="mb-6">
      {@render step?.(activeIndex, steps[activeIndex])}
    </div>

    {#if footer}
      {@render footer({ activeIndex, isLast, back, next })}
    {:else}
      <div class="flex justify-between">
        <button type="button" class="btn" onclick={back} disabled={activeIndex === 0}>Back</button>
        {#if !isLast}
          <button type="button" class="btn btn-primary" onclick={next}>Continue</button>
        {/if}
      </div>
    {/if}
  </div>
</div>
